// One witness shape for every controlled-drug event (administration,
// correction, void, destruction, discarding an empty container). Mirrors
// server/src/helpers/medsMx/witness.js and mobile/src/components/EPCR/witness.js.
//
// Picker state keeps the chosen colleague as the full user object (what the
// EmployeeSelector works with); toWitnessPayload() flattens it for the API:
//   { type: 'colleague', user: <id> }
//   { type: 'external', name, email, phone }

export const emptyWitness = () => ({
  type: 'colleague',
  user: null,
  name: '',
  email: '',
  phone: '',
})

export const isWitnessComplete = (witness) => {
  if (!witness) return false
  if (witness.type === 'colleague') return !!witness.user?._id
  return !!(
    witness.name?.trim() &&
    witness.email?.trim() &&
    witness.phone?.trim()
  )
}

// undefined when incomplete, so callers can spread it straight into a
// request body without sending a half-filled witness.
export const toWitnessPayload = (witness) => {
  if (!isWitnessComplete(witness)) return undefined
  return witness.type === 'colleague'
    ? { type: 'colleague', user: witness.user._id }
    : {
        type: 'external',
        name: witness.name.trim(),
        email: witness.email.trim(),
        phone: witness.phone.trim(),
      }
}

export const witnessDisplayName = (witness) => {
  if (!isWitnessComplete(witness)) return ''
  return witness.type === 'colleague'
    ? `${witness.user.firstName ?? ''} ${witness.user.lastName ?? ''}`.trim()
    : `${witness.name.trim()} (external)`
}

// Picker state from a stored log whose `witness.user` is populated with
// names, for prefilling a correction. Legacy logs only carry the free-text
// `witnessedBy` and cannot be prefilled - the picker starts empty.
export const witnessFromLog = (log) => {
  const stored = log?.witness
  if (stored?.type === 'colleague' && stored.user?._id) {
    return { ...emptyWitness(), type: 'colleague', user: stored.user }
  }
  if (stored?.type === 'external') {
    return {
      type: 'external',
      user: null,
      name: stored.name ?? '',
      email: stored.email ?? '',
      phone: stored.phone ?? '',
    }
  }
  return emptyWitness()
}
